export const MOSTRAR_ALERTA = "MOSTRAR_ALERTA";
export const OCULTAR_ALERTA = "OCULTAR_ALERTA";
///////////////////////////////////////////////////////////////////////
export const REGISTRO_EXITOSO = "REGISTRO_EXITOSO";
export const REGISTRO_ERROR = "REGISTRO_ERROR";
export const OBTENER_USUARIO = "OBTENER_USUARIO";
export const OBTENER_TODOS_LOS_USUARIOS = "OBTENER_TODOS_LOS_USUARIOS";
export const ACTUALIZAR_USUARIO = "ACTUALIZAR_USUARIO";
///////////////////////////////////////////////////////////////////////
export const LOGIN_EXITOSO = "LOGIN_EXITOSO";
export const LOGIN_ERROR = "LOGIN_ERROR";
export const CERRAR_SESION = "CERRAR_SESION";
export const ACTUALIZAR_PASSWORD = "ACTUALIZAR_PASSWORD";
export const ENVIAR_PASSWORD = "ENVIAR_PASSWORD";
/////////////////////////////////////////////////////////////////////
export const REGISTRO_FICHATECNICA_EXITOSA = "REGISTRO_FICHATECNICA_EXITOSA";
export const REGISTRO_FICHATECNICA_ERROR = "REGISTRO_FICHATECNICA_ERROR";
export const TODAS_LAS_FICHAS_TECNICAS = "TODAS_LAS_FICHAS_TECNICAS";
export const FICHATECNICA_ACTUAL = "FICHATECNICA_ACTUAL";
export const FICHA_EDICION = "FICHA_EDICION";
export const ACTUALIZAR_FICHA = "ACTUALIZAR_FICHA";
export const ENVIAR_GUARDAR_COTIZACION = "ENVIAR_GUARDAR_COTIZACION";
export const EXCEL_REPORTE_DOS = "EXCEL_REPORTE_DOS";
//////////////////////////////////////////////////////////////////
export const OBTENER_DATOS_TABLA = "OBTENER_DATOS_TABLA";
export const OBTENER_DATOS_TABLA_REPORTE = "OBTENER_DATOS_TABLA_REPORTE";
export const OBTENER_DATOS_TABLA_GERENTE_GENERAL =
  "OBTENER_DATOS_TABLA_GERENTE_GENERAL";
export const AGREGAR_DATOS_TABLA = "AGREGAR_DATOS_TABLA";
export const ACTUALIZAR_DATOS_TABLA = "ACTUALIZAR_DATOS_TABLA";
export const GUARDAR_COTIZACIONES = "GUARDAR_COTIZACIONES";
export const GUARDAR_COTIZACIONES_EN_LA_BD = "GUARDAR_COTIZACIONES_EN_LA_BD";
export const ALTA_NEGOCIO = "ALTA_NEGOCIO";
export const ALTA_NEGOCIO_GERENTE_ADMINISTRACION =
  "ALTA_NEGOCIO_GERENTE_ADMINISTRACION";
export const ELIMINAR_TABLA = "ELIMINAR_TABLA";
export const ERROR_TABLA = "ERROR_TABLA";
export const ERROR_TABLA_DETALLE = "ERROR_TABLA_DETALLE";
